import PostMessageToRnWebview from '../../../../services/PostMessageToRnWebview';
import { $stateParams } from '../../../../router';
import RSVP_CONSTS from '../../../../constants';

const buildAttendanceObject = (attendance, contact) => ({
    id: attendance.id,
    entityId: attendance.event_id,
    eventId: parseInt($stateParams.event_id),
    status: RSVP_CONSTS.ATTENDANCE.TITLES[attendance.status],
    guestCount: attendance.attendances_count - 1,
    contactId: contact.id,
    contactUniqueId: $stateParams.contact_uuid,
    email: contact.email,
    name: contact.full_name
});

const buildAttendancesArray = (attendances, contact) => {
    const array = Array.isArray(attendances) ? attendances : [attendances];
    return array.map(attendance => buildAttendanceObject(attendance, contact));
};

const TriggerPostMessageEvent = (action, data=[]) => {
    console.log('PostMessage Triggered', JSON.stringify({
        source: 'rsvp-lite',
        action,
        data
    }));
    return PostMessageToRnWebview({ 
        source: 'rsvp-lite',
        action,
        data
    }).catch(console.error);
};

export const AddAttendancePostMessage     = (attendance, contact) => TriggerPostMessageEvent('attendance-add', buildAttendancesArray(attendance, contact));
export const ChangeAttendancePostMessage  = (attendance, contact) => TriggerPostMessageEvent('attendance-change', buildAttendancesArray(attendance, contact));
export const CancelAttendancePostMessage  = (attendance, contact) => TriggerPostMessageEvent('attendance-cancel', buildAttendancesArray(attendance, contact));

export default { 
    AddAttendancePostMessage,
    ChangeAttendancePostMessage,
    CancelAttendancePostMessage
};